import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class FactoryCapacityProvider extends HttpRequest {
  constructor () {
    super(`${process.env.VUE_APP_MER_API}/factory-capacity`)
  }

  getSummary (query) {
    this.setHeader(getAuthToken())
    return this.get('/summary', query)
  }

  getUtilization (query) {
    this.setHeader(getAuthToken())
    return this.get('/utilization', query)
  }

  getProducts (query) {
    this.setHeader(getAuthToken())
    return this.get('/products', query)
  }

  getRebalanceSuggestion () {
    this.setHeader(getAuthToken())
    return this.get('/rebalance-suggestion')
  }

  getRebalanceSettings () {
    this.setHeader(getAuthToken())
    return this.get('/rebalance-settings')
  }

  updateRebalanceSettings (payload) {
    this.setHeader(getAuthToken())
    return this.put('/rebalance-settings', payload)
  }
}

export default FactoryCapacityProvider
